import Api, { baseURL } from '../Api'

const BASE_ROOT = `${baseURL('v2')}`
const BASE = `${BASE_ROOT}/{departamento}/sistema/produtividade-params`

export default {
  current() {
    return Api.get(BASE)
  },

  update(params) {
    return Api.post(BASE, params)
  },
}
